import { Component } from '@angular/core';
import { ToggleTextModule } from '../../../../../components/toggle-text/toggle-text.module';


@Component({
  selector: 'demo-toggle-text',
  standalone: true,
  imports: [ToggleTextModule],
  templateUrl: './demo-toggle-text.component.html',
  styleUrl: './demo-toggle-text.component.scss',
})
export class DemoToggleTextComponent {}
